const staticvariable = {
  business: {
    10: "火车票",
    20: "酒店",
    30: "国际机票",
    40: "国内机票",
    50: "打车"
  },
  //火车票搜索供应
  searchSupply: {
    1: "同城",
    3: "51book",
    7: "万顺",
    8: "东美",
    12: "差旅天下",
    15: "票多多",
    16: "MT火车票",
    17: "梵泽科技",
    18: "星河智联",
    20: "美享",
    22: "连铁",
    23: "梓如",
    "-1": "无"
  },
  //火车票购票供应(弃用  使用trainsSupplys
  trainsSupply: {
    0: [{supplierId:8,supplierName:"东美商旅"},{supplierId:12,supplierName:"差旅天下"},{supplierId:-1,supplierName:"无"}],
    1: [{supplierId:4,supplierName:"12306自购"},{supplierId:1,supplierName:"同程(自购)"},{supplierId:-1,supplierName:"无"}],
    2: [{supplierId:3,supplierName:"51Book(现金票)"},{supplierId:7,supplierName:"万顺(现金票)"},{supplierId:-1,supplierName:"无"}],
    3: [{supplierId:11,supplierName:"51Book(电子票)"},{supplierId:10,supplierName:"万顺(电子票)"},{supplierId:13,supplierName:"票池网"},{supplierId:-1,supplierName:"无"}],
  },
  //火车票购票供应 选择框信息
  trainsSupplys: {
    "specialElectronicBuy":[],
    "agentBuy": [],
    "specialAgentBuy":[],
    "selfBuy": [],
    "other":[]
  },
  buyModel:{
    0:"商旅代购",
    1:"自购",
    2:"现金票代购",
    3:"电子票代购"
  },
  buyModelEnum:{
    0:"agentBuy",
    1:"selfBuy",
    2:"specialAgentBuy",
    3:"specialElectronicBuy"
  },
  orderState: {
    10: "创建",
    20: "占座中",
    30: "占座成功",
    40: "出票中",
    50: "出票成功",
    60: "占座失败",
    70: "取消订单"
  },
  trainType: {
    1: "成人票",
    2: "儿童票",
    3: "学生票",
    4: "残军票"
  },
  baseConfig:{
    "search_supplier_config":"供应配置查询"
  },
  seatClass:{
    1:"硬座",
    2:"软座",
    3:"一等座",
    4:"二等座",
    5:"硬卧上铺",
    6:"硬卧",
    7:"硬卧下铺",
    8:"软卧上铺",
    9:"软卧",
    10:"无座",
    11:"商务座",
    12:"特等座",
    13:"高级软卧",
    14:"其他",
    15:"动卧上铺",
    16:"动卧下铺",
    17:"高级动卧上铺",
    18:"高级动卧下铺",
    19:"高级软卧上铺",
    20:"高级软卧下铺",
    21:"一等卧上铺",
    22:"一等卧下铺",
    23:"二等卧上铺",
    24:"二等卧中铺",
    25:"二等卧下铺",
    26:"包厢硬卧上铺",
    27:"包厢硬卧中铺",
    28:"包厢硬卧下铺",
    29:"一人软包",
    30:"多功能座",
    31:"特等软座",


    32:"软卧",
    33:"硬卧",
    34:"一等卧",
    35:"二等卧",
    36:"高级动卧",
    37:"动卧",
    38:"包厢硬卧",
    39:"一等软座",
    40:"二等软座",
    41:"混编硬座",
    42:"混编硬卧",
    43:"包厢软座",
    44:"二人软包",
    45:"混编软座",
    46:"混编软卧",
    47:"二等包座"
  }

};

export default staticvariable;
